import {Toast} from 'antd-mobile/es'

import projectConfig from '../../config'
import axios from './axios'
import {generateSecureNonce, getBrowserFingerprint, isBrowser} from './helper'

interface ReqParams {
  url: string
  params: any
  method?: 'get' | 'post'
  needToken?: boolean // 是否需要token
  useOrigin?: boolean // 是否使用原始域名
  returnAll?: boolean
}

function fullURL(url: string) {
  const {proxies = []} = projectConfig[ENV]
  for (let i = 0; i < proxies.length; i += 1) {
    const {match, map, host} = proxies[i]
    if (match.test(url)) {
      const realURL = host + map(url)
      return isBrowser() ? url : realURL
    }
  }
  return url
}

/**
 * 按键名字典序排序对象
 * @param obj 要排序的对象
 * @returns 排序后的新对象
 */
const sortObjectByKeys = (obj: Record<string, any>): Record<string, any> => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }
  const sortedObj: Record<string, any> = {}
  Object.keys(obj)
    .sort() // 按键名字典序排序
    .forEach((key) => {
      sortedObj[key] = obj[key]
    })
  return sortedObj
}

const getCommonData = async () => {
  return {
    nonce: await generateSecureNonce(),
    deviceId: await getBrowserFingerprint(),
    ...window.store.getState().deviceInfo,
  }
}

const tokenHanlder = () => {
  Toast.clear()
}

export async function req(args: ReqParams): Promise<any> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const {
      url,
      params,
      method = 'post',
      needToken = false,
      useOrigin = false,
      returnAll = false,
    } = args
    const commonData = await getCommonData()
    const currentUrl = useOrigin ? url : fullURL(url)
    const globalParams = {
      ...params,
      ...commonData,
    }
    const currentParams = useOrigin ? params : globalParams

    if (needToken) {
      // 获取token
    }
    // console.log('[request] req ===> ', currentParams)
    try {
      const sortedParams = sortObjectByKeys(currentParams)
      const isGet = method === 'get'
      const res: any = await axios(currentUrl, {
        method,
        ...(isGet ? {params: sortedParams} : {data: sortedParams}),
        headers: {
          Authorization: commonData?.token,
        },
      })
      // console.log('[request] res ===> ', res)
      if (returnAll) {
        resolve(res)
        return
      }
      if (+res.code === 0 || +res.ret === 1) {
        resolve(res.data)
        return
      }
      const tokenLoseEffective = res.ret === -1006 || res.ret === -1007
      // token 失效
      if (tokenLoseEffective && isBrowser()) {
        tokenHanlder()
        return
      }
      reject(new Error(res.msg))
    } catch (error) {
      // console.error('[request] error ===> ', error)
      reject(error)
    }
  })
}

export async function reqLog(args: any) {
  const data = await getCommonData()
  const params = {
    ...data,
    list: [args],
    cancelType: 3,
  }
  const url = fullURL('/xs-api/stat/action')
  axios.post(url, {...params})
}
